import t from "components/i18n";

export default function getValidationMessage(prop, errors, pristine) {
  if (pristine) {
    return null;
  }

  return t(errors[prop]);
}
